import { render, staticRenderFns } from "./item5.vue?vue&type=template&id=5c2aaf23&scoped=true"
import script from "./item5.vue?vue&type=script&lang=js"
export * from "./item5.vue?vue&type=script&lang=js"
import style0 from "./item5.vue?vue&type=style&index=0&id=5c2aaf23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2aaf23",
  null
  
)

export default component.exports